module.exports = __webpack_public_path__ + "static/media/icon_success.73a89c63.svg";